import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

const BASE_TITLE = "MyListIQ";
const DEFAULT_TITLE = "Easy, Affordable Real Estate Marketing";

const routeTitles: Array<{ path: string; title: string }> = [
  { path: "/", title: "Home" },
  { path: "/about", title: "About" },
  { path: "/contact", title: "Contact" },
  { path: "/pricing", title: "Pricing" },
  { path: "/signup", title: "Sign Up" },
  { path: "/forgot-password", title: "Forgot Password" },
  { path: "/set-password/:uidb64/:token", title: "Set Password" },
  { path: "/success", title: "Payment Success" },
  { path: "/failure", title: "Payment Failed" },
  { path: "/terms-and-conditions", title: "Terms and Conditions" },
  { path: "/privacy-policy", title: "Privacy Policy" },
  { path: "/broker", title: "Broker Services" },
  { path: "/beta-checklist", title: "Beta Checklist" },
  { path: "/beta-agreement", title: "Beta Agreement" },
  { path: "/dashboard", title: "Dashboard" },
  { path: "/templates", title: "Templates" },
  { path: "/template-builder", title: "Template Builder" },
  { path: "/template-preview/:id", title: "Template Preview" },
  { path: "/flyer-editor/:templateId", title: "Flyer Editor" },
  { path: "/builder/:templateId", title: "Launch Builder" },
  { path: "/builder", title: "Launch Builder" },
  { path: "/addons/success", title: "Add-On Success" },
  { path: "/service-campaign", title: "Service Launch" },
  { path: "/agent", title: "My Hubs" },
  { path: "/propertyimport", title: "Property Import" },
  { path: "/launches", title: "Launches" },
  { path: "/launches-edit/:id", title: "Edit Launch" },
  { path: "/launches-view/:id", title: "Launch View" },
  { path: "/analytics", title: "Analytics" },
  { path: "/social-media", title: "Social Media Uploads" },
  { path: "/saved-templates", title: "Saved Templates" },
  { path: "/settings", title: "Settings" },
  { path: "/help", title: "Help" },
  { path: "/manage/users", title: "Admin Users" },
  { path: "/draft-campaign", title: "Draft Launch" },
  { path: "/templates/Template1", title: "Template 1" },
  { path: "/templates/Template2", title: "Template 2" },
  { path: "/templates/Template3", title: "Template 3" },
  { path: "/templates/Template4", title: "Template 4" },
  { path: "/templates/Template5", title: "Template 5" },
  { path: "/templates/Template6", title: "Template 6" },
  { path: "/templates/Template7", title: "Template 7" },
  { path: "/templates/Template8", title: "Template 8" },
  { path: "/templates/Template9", title: "Template 9" },
  { path: "/templates/Template10", title: "Template 10" },
  { path: "/templates/Template11", title: "Template 11" },
  { path: "/templates/MultiTemplate", title: "Multi Template" },
];

function getPageTitle(pathname: string) {
  const match = routeTitles.find(({ path }) =>
    matchPath({ path, end: true }, pathname)
  );

  if (!match) {
    return `${BASE_TITLE} - ${DEFAULT_TITLE}`;
  }

  return `${BASE_TITLE} | ${match.title}`;
}

const PageTitle: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = getPageTitle(location.pathname);
  }, [location.pathname]);

  return null;
};

export default PageTitle;
